
import React from "react";
import CaseStudyCard from "./CaseStudyCard";
import { CaseStudy } from "./types";

interface CaseStudyCardsProps {
  study: CaseStudy;
}

const CaseStudyCards = ({ study }: CaseStudyCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 px-2 md:px-4">
      {study.cards.map((card, i) => (
        <CaseStudyCard 
          key={`${study.id}-card-${i}`}
          card={card}
          studyId={study.id}
          index={i}
        />
      ))}
    </div>
  );
};

export default CaseStudyCards;
